import { GDAIChatRequest, GDAIChatResponse } from '@/types';
import { buildAPIUrl, responseInterceptor } from '.';

export const gdAIchat = async (chatRequest: GDAIChatRequest): Promise<GDAIChatResponse> => {
  const resp = await responseInterceptor(
    await fetch(`${await buildAPIUrl()}/services/gdai/chat`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(chatRequest),
    }),
  );

  return resp.json();
};

export const gdAISummary = async (
  reportId: number,
): Promise<{
  success: boolean;
  error: string | null;
  response: {
    document_id: string;
    title: string;
    summary: string;
    url: string;
    published_date: string;
    truncated: boolean;
    text_chunks_read: number;
  } | null;
}> => {
  const requestData = {
    id: `${reportId}`,
  };

  const resp = await responseInterceptor(
    await fetch(`${await buildAPIUrl()}/services/gdai/nova/summary`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData),
    }),
  );

  return resp.json();
};
